import { Box, Image, Text, Spinner, VStack, Flex, Icon } from "@chakra-ui/react";
import { useState } from "react";
import { formatNumber } from "../../utils/helper";
import { CheckCircleIcon } from "@chakra-ui/icons"; // Импорт иконки галочки
import ethBadgeImage from '../../assets/images/png/Badge_Ethereum_Year.png';

const BadgeCard = ({ badge, isMobile }) => {
	const [loaded, setLoaded] = useState(false);

	return (
		<Box
			bg="white"
			p={4}
			borderRadius="15px"
			boxShadow="lg"
			textAlign="center"
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="space-between"
			width={"200px"}
			height={"220px"}
			cursor="pointer" // Изменить курсор на указатель
			transition="transform 0.2s" // Плавный переход
			_hover={{ transform: 'scale(1.05)' }} // Увеличение при наведении
			border={badge.isMinted ? '2px solid green' : 'none'} // Добавляем обводку, если бейдж существует
			position="relative" // Позволяет разместить галочку в правом верхнем углу
			overflow="hidden" // Убедитесь, что ничего не выходит за пределы контейнера
		>
			{/* Показываем спиннер, пока изображение загружается */}
			{!loaded && (
				<Box
					display="flex"
					justifyContent="center"
					alignItems="center"
					height={isMobile ? "100px" : "200px"}
					width={isMobile ? "100px" : "200px"}
					position="absolute"
					top={0}
					left={0}
					bg="white"
					zIndex={1}
				>
					<Spinner size="xl" />
				</Box>
			)}

			{/* Основное изображение бейджа */}
			{badge.images && badge.images.length > 0 ? (
				<VStack spacing={2} align="center" height="100%" width="100%">
					<Flex flexFlow={"wrap"} justifyContent={"center"}>
						{badge.images.map((image, index) => (
							<Image
								key={index}
								src={image}
								alt={badge.name}
								borderRadius="10px"
								display={loaded ? 'block' : 'none'}
								onLoad={() => setLoaded(true)}
								width={isMobile ? "40%" : "65%"}
								objectFit="cover"
							/>
						))}
					</Flex>
				</VStack>
			) : (
				<Image
					src={!badge.name.includes('Ethereum Year') ? badge.image : ethBadgeImage}
					alt={badge.name}
					borderRadius="10px"
					display={loaded ? 'block' : 'none'}
					onLoad={() => setLoaded(true)}
					width={"65%"}
					objectFit="cover"
				/>
			)}

			{/* Отображаем галочку, если бейдж существует */}
			{badge.isMinted && (
				<Box
					position="absolute"
					top={2}
					right={2}
					background="white"
					borderRadius="full"
					boxShadow="md"
					p={1}
					zIndex={2} // Обеспечиваем, что галочка поверх изображения
				>
					<Icon as={CheckCircleIcon} color="green.500" boxSize={6} />
				</Box>
			)}

			{/* Название бейджа */}
			<Text fontWeight="bold" mt={2} maxW="180px" minH="20px" isTruncated>{badge.name}</Text>
			{/* Отображаем количество и процент */}
			<Text mt={1} flexGrow={1}>{formatNumber(badge.count)} / {badge.percentage}%</Text>
		</Box>
	);
};

export default BadgeCard;
